import React from "react";
import "./resources.css";
import Footer from "../Footer";

const Templates = () => {
  return (
    <div className="resource-page">
      <div className="resource-container">
        <h1>Templates</h1>
        <p className="resource-subtitle">
          Useful business templates to help SMEs manage operations, records,
          invoicing, and reporting.
        </p>

        <section className="resource-section">
          <h2>Available Templates</h2>

          <div className="resource-grid">
            <div className="resource-card">
              <h3>Invoice Template</h3>
              <p>
                A clean invoice structure including customer details, invoice
                items, VAT, subtotal, total, and payment terms.
              </p>
            </div>

            <div className="resource-card">
              <h3>Receipt Template</h3>
              <p>
                A professional receipt format for confirming customer payments.
              </p>
            </div>

            <div className="resource-card">
              <h3>Expense Tracker</h3>
              <p>
                Track business expenses by date, vendor, category, amount, and
                payment method.
              </p>
            </div>

            <div className="resource-card">
              <h3>Customer Statement</h3>
              <p>
                Summarise customer invoices, payments, outstanding balances, and
                due dates.
              </p>
            </div>

            <div className="resource-card">
              <h3>Inventory Sheet</h3>
              <p>
                Record stock items, opening quantity, purchases, sales,
                adjustments, and closing stock.
              </p>
            </div>

            <div className="resource-card">
              <h3>Cash Flow Planner</h3>
              <p>
                Plan expected inflows, outflows, available cash, and funding
                gaps.
              </p>
            </div>
          </div>
        </section>

        <section className="resource-section">
          <h2>Coming Soon</h2>
          <div className="resource-card full">
            <p>
              Downloadable Excel, PDF, and Google Sheet templates will be added
              soon. Some templates may be available based on your KostPadi
              subscription plan.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Templates;
